import { AxiosError, AxiosResponse } from 'axios'
import { getRequestTime } from '..'
import singleServiceTime from '@xt/client/experimental/server-time'
import moment from 'moment'

export const syncTimeResponseInterceptors = {
  success: (response: AxiosResponse) => {
    syncServiceTime(response)
    return response
  },
  fail: (error: AxiosError) => {
    syncServiceTime(error.response!)
    throw error
  }
}

function syncServiceTime(response: AxiosResponse) {
  if (!response) return

  try {
    const rtt = Date.now() - getRequestTime()
    const delay = Math.ceil(rtt / 2)
    const ignoreList = ['json', 'JSON', 'jpg', 'png', 'jpeg', 'html']
    const url = response.config.url?.split('?')[0] as string
    if (!ignoreList.includes(url.slice(url.lastIndexOf('.') + 1, url.length))) {
      const serviceDate = response.headers['date']
      if (serviceDate) {
        const clientTime = Date.now()
        const serverTime = moment(serviceDate).utcOffset(+8).valueOf()
        // diff = 服务端时间 + 单向网络时延 - 客户端时间
        singleServiceTime.clientServerDateDiff = serverTime + delay - clientTime
      }
    }
  } catch (error) {
    console.error('获取系统时间错误')
  }
}
